import refund from '../en/refund'

const cnRefund = {}

for (const cn in refund) {
  cnRefund[cn] = cn
}

export default cnRefund
